import moment from "moment";
export const dateTimeFormat = (date) => {
  try {
    console.log("dateandtime: ", date);
    if (date && date !== "--") {
      return moment(date).format("DD.MM.YYYY HH:mm");
    } else {
      return "N/A";
    }
  } catch (error) {
    return "N/A";
  }
};

export const dateFormat = (date) => {
  try {
    console.log("date: ", date);
    if (date && date !== "--") {
      return moment(date).format("DD.MM.YYYY");
    } else {
      return "N/A";
    }
  } catch (error) {
    return "N/A";
  }
};

export const timeFormat = (date) => {
  try {
    console.log("time: ", date);
    if (date && date !== "--") {
      return moment(date).format("HH:mm");
    } else {
      return "N/A";
    }
  } catch (error) {
    return "N/A";
  }
};
